import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Keyboard } from "@capacitor/keyboard";
import { App as CapApp } from "@capacitor/app";
import { Haptics, ImpactStyle } from "@capacitor/haptics";

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

/**
 * Initialize native-only behaviour. Safe to call on web (no-ops).
 */
export async function initNative() {
  if (!isNative()) return;

  try {
    await StatusBar.setStyle({ style: Style.Dark });
    if (platform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#1e3a5f" });
    }
  } catch (e) {
    console.warn("StatusBar init failed", e);
  }

  try {
    await SplashScreen.hide({ fadeOutDuration: 300 });
  } catch {
    /* ignore */
  }

  // Hardware back button on Android: exit app on root, otherwise navigate back
  try {
    CapApp.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        CapApp.exitApp();
      }
    });
  } catch {
    /* ignore */
  }

  // Hide keyboard accessory bar style tweaks
  try {
    Keyboard.addListener("keyboardWillShow", () => {
      document.body.classList.add("keyboard-open");
    });
    Keyboard.addListener("keyboardWillHide", () => {
      document.body.classList.remove("keyboard-open");
    });
  } catch {
    /* ignore */
  }
}

export async function tapHaptic(style: ImpactStyle = ImpactStyle.Light) {
  if (!isNative()) return;
  try {
    await Haptics.impact({ style });
  } catch {
    /* ignore */
  }
}
